<button [matMenuTriggerFor]="operatorMenu" class="operator" mat-stroked-button>
  {{ 'sem_table.' + operatorCtrl.value | translate }}
  <mat-icon>arrow_drop_down</mat-icon>
</button>

<mat-menu #operatorMenu="matMenu" class="column-menu" xPosition="after">
  <button (click)="setOrOperator()" mat-menu-item>{{ 'sem_table.or' | translate }}</button>
  <button (click)="setAndOperator()" mat-menu-item>{{ 'sem_table.and' | translate }}</button>
</mat-menu>
